<template>
  <v-card height="100%" class="messsges-box" elevation="1">
    <v-toolbar>
      <v-toolbar-title>
        <span>
          <h3 class="font-weight-light">
            {{ $t("messanger.dash.name") }}
            <span class="caption">( {{ typeMessanger }} )</span>
          </h3>
        </span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip top color="black">
        <template v-slot:activator="{ on }">
          <v-btn dark color="black" v-on="on" @click="notificationState" icon>
            <v-icon
              v-if="$store.state.messages.NotificationPush"
              :size="$store.state.isMobile ? 20 : 27"
            >
              mdi-bell-ring
            </v-icon>
            <v-icon v-else :size="$store.state.isMobile ? 20 : 27">
              mdi-bell-off
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("messanger.dash.notificationPush") }}</span>
      </v-tooltip>

      <v-btn
        :disabled="!selected.length"
        icon
        color="error"
        @click="msg_delete(selected)"
      >
        <v-icon :size="$store.state.isMobile ? 20 : 27">mdi-delete</v-icon>
        <v-fab-transition>
          <v-badge
            v-show="selected.length"
            color="error darken-3"
            :content="selected.length"
            overlap
            bordered
            offset-x="10"
            offset-y="20"
          />
        </v-fab-transition>
      </v-btn>

      <v-tooltip top color="black">
        <template v-slot:activator="{ on }">
          <v-btn dark color="black" v-on="on" @click="refresh" icon>
            <v-icon :size="$store.state.isMobile ? 20 : 27"
              >mdi-refresh-circle</v-icon
            >
          </v-btn>
        </template>
        <span>{{ $t("messanger.dash.refresh") }}</span>
      </v-tooltip>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="filteredDesserts"
      :loading="this.$store.state.messages.loading"
      :search="search"
      hide-default-header
      item-key="name"
      class="elevation-1 dash"
      show-select
      :footer-props="{
        'items-per-page-options': [30, 70, 100],
        itemsPerPageText: $t('messanger.dash.footer'),
      }"
      :loading-text="$t('messanger.dash.loader')"
      @page-count="pageCount = $event"
      @update:page="paginate"
      :page.sync="$store.state.messages.last_page"
      @pagination="updatePage"
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("messanger.dash.no_data")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:no-results>
        <v-alert
          :value="true"
          outlined
          text
          color="error"
          icon="mdi-alert"
          class="mt-4 text--center"
          >{{ `${$t("users.dash.no_result")} '${search}'` }}</v-alert
        >
      </template>
      <template v-slot:top>
        <v-expansion-panels
          v-model="$store.state.messages.filter_panel_open"
          multiple
        >
          <v-expansion-panel class="white--text">
            <v-expansion-panel-header color="rgb(17, 65, 206)">
              <template v-slot:actions>
                <v-icon color="white"> mdi-arrow-down-drop-circle </v-icon>
              </template>
              <template v-slot:default="{ open }">
                <v-row no-gutters justify="start">
                  <v-col cols="4"> <h4>Options</h4> </v-col>
                  <v-col cols="5">
                    <v-fade-transition leave-absolute>
                      <span v-if="!open">
                        <b>Mode : </b>
                        {{
                          typeof $store.state.messages.sorts.conversation
                            .filter_by === "object"
                            ? $store.state.messages.sorts.conversation
                                .filter_by[0] === "show_all"
                              ? $t("messanger.dash.filters.mode.show_all")
                              : $t(
                                  "messanger.dash.filters.mode.show_conversations"
                                )
                            : $store.state.messages.sorts.conversation
                                .filter_by === "show_all"
                            ? $t("messanger.dash.filters.mode.show_all")
                            : $t(
                                "messanger.dash.filters.mode.show_conversations"
                              )
                        }}
                      </span>
                    </v-fade-transition>
                    <v-fade-transition v-if="set_filter" leave-absolute>
                      <span v-if="!open">
                        , <b>Filter by : </b>{{ filters_display(set_filter) }}
                      </span>
                    </v-fade-transition>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content color="#fafafa">
              <v-row dense no-gutters>
                <v-col cols="12">
                  <Tracking />
                </v-col>
                <v-col cols="12">
                  <FilterMode />
                </v-col>
                <v-col cols="12">
                  <add-agent-box />
                </v-col>
                <v-col cols="12">
                  <v-row justify="center">
                    <v-col cols="10" sm="6">
                      <v-select
                        light
                        :menu-props="{ bottom: true, offsetY: true }"
                        :items="filters"
                        v-model="set_filter"
                        single-line
                        hide-details
                        reguler
                        clearable
                        :label="$t('messanger.dash.filters.select.name')"
                        @change="clear"
                        class="ma-0 py-0"
                      >
                        <template slot="selection" slot-scope="{ item }">
                          {{ $t(`messanger.dash.filters.select.${item.text}`) }}
                        </template>
                        <template v-slot:item="{ item }">
                          {{ $t(`messanger.dash.filters.select.${item.text}`) }}
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12">
                      <Filters
                        :name="set_filter"
                        :btns="btns"
                        :data="filteredDesserts"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-toolbar color="light" elevation="0" class="ma-4">
          <v-row dense no-gutters justify="center">
            <v-col cols="12" sm="9">
              <v-text-field
                v-model="localSearch"
                append-icon="mdi-magnify"
                :label="$t('messanger.dash.search')"
                single-line
                hide-details
                reguler
                clearable
                outlined
                type="search"
                name="search-conversations"
                autofill="off"
                autocomplete="off"
                @click:append="triggerSearch"
                @click:clear="clearSearch"
                @input="localSearch === '' ? clearSearch() : null"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-row dense justify="center" align="center">
          <v-col cols="auto" v-if="$store.state.isMobile">
            <span
              class="caption v-btn--depressed v-btn--flat theme--light v-size--small"
            >
              <strong>{{ $t("messanger.dash.footer") }}</strong>
              {{ page_infos.pageStart }}-{{ page_infos.pageStop }}
              <strong>of</strong> {{ page_infos.itemsLength }}
            </span>
          </v-col>
          <span
            v-else
            class="caption v-btn--absolute v-btn--depressed v-btn--flat v-btn--right theme--light v-size--small"
          >
            <strong>{{ $t("messanger.dash.footer") }}</strong>
            {{ page_infos.pageStart }}-{{ page_infos.pageStop }}
            <strong>of</strong>
            {{ $store.state.messages.store_conversation_length }}
          </span>
          <v-col cols="12">
            <v-pagination
              v-show="filteredDesserts.length"
              v-model="$store.state.messages.last_page"
              :length="pageCount"
              :total-visible="$store.state.isMobile ? 5 : 7"
              color="rgb(17, 65, 206)"
            ></v-pagination>
          </v-col>
          <v-col cols="12" v-if="$store.state.isMobile">
            <v-row dense no-gutters justify="center" align="center">
              <v-col cols="auto">
                <span class="mx-2 caption">{{
                  $t("messanger.dash.select_all")
                }}</span>
              </v-col>
              <v-col cols="auto">
                <span class="mx-2">
                  <v-btn icon small @click="toggleAll()">
                    <v-icon :color="selected.length ? 'primary' : ''">{{
                      selected.length
                        ? `mdi-checkbox-blank-off-outline`
                        : `mdi-checkbox-blank-outline`
                    }}</v-icon>
                  </v-btn>
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template v-slot:header>
        <thead v-if="!$store.state.isMobile">
          <tr class="text-center">
            <td
              v-for="header in headers"
              :key="header.text"
              style="border-bottom: 2px solid #d8d7d7; font-weight: 600"
              :style="{ minWidth: header.minWidth }"
              class="ma-0 pa-0"
              v-show="checkTrackingLabes(header.value)"
            >
              <span v-if="header.box">
                <v-btn icon small @click="toggleAll()">
                  <v-icon :color="selected.length ? 'primary' : ''">{{
                    selected.length
                      ? `mdi-checkbox-blank-off-outline`
                      : `mdi-checkbox-blank-outline`
                  }}</v-icon>
                </v-btn>
              </span>
              <span v-else>
                {{ header.text }}
              </span>
            </td>
          </tr>
        </thead>
      </template>
      <template v-slot:item="{ item, index }">
        <Tbody
          :item="item"
          :selected="selected"
          :receiver_ids="receiver_ids"
          v-if="!$store.state.isMobile"
        />
        <TbodyMobile
          v-else
          :item="item"
          :index="index"
          :selected="selected"
          :receiver_ids="receiver_ids"
        />
      </template>
    </v-data-table>
    <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        color="#1141ce"
        @click="$vuetify.goTo(0)"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-card>
</template>

<script>
import Tbody from "./MessageDashFiles/Tbody";
import Filters from "./MessageDashFiles/Filters";
import TbodyMobile from "./MessageDashFiles/TbodyMobile";
import Tracking from "./MessageDashFiles/Tracking.vue";
import AddAgentBox from "./MessageDashFiles/AddAgentBox.vue";
import FilterMode from "./MessageDashFiles/Filter_mode";

export default {
  data: () => ({
    pagination: {
      sortBy: "name",
    },
    selected: [],
    receiver_ids: [],
    headers: [],
    filters: [
      { text: "Online", value: "online" },
      { text: "Priority", value: "priority" },
      { text: "Waiting", value: "waiting" },
      { text: "Status", value: "status" },
      { text: "status_email", value: "status_email" },
      { text: "add_to_cart", value: "add_to_cart" },
      { text: "purchase", value: "purchase" },
    ],
    date: false,
    pageCount: 0,
    search: "",
    localSearch: "",
    set_filter: null,
    btns: {
      btn1: false,
      btn2: false,
    },
    page_infos: {},
    fab: false,
    ex1: null,
  }),
  components: {
    Tbody,
    Filters,
    TbodyMobile,
    FilterMode,
    Tracking,
    AddAgentBox,
  },
  async mounted() {
    try {
      if (!this.$store.state.messages.pull_call) {
        this.$store.state.messages.loading = true;
        await this.$store.dispatch("FETCH_MESSAGES", {
          page: 0,
          type: this.$store.state.messanger_type_selected,
        });
      }
      this.set_filter = this.$store.state.messages.sorts.selected_sort;
      this.$store.state.messages.loading = false;
    } catch (e) {
      console.log(e.response);
      this.$store.state.messages.loading = false;
    }
  },
  computed: {
    filteredDesserts() {
      this.initlables();
      return this.$store.state.messages.filter_rest;
    },
    typeMessanger() {
      const data = this.$store.state.messangerItems[
        this.$store.state.messanger_type_selected
      ];
      return data.name;
    },
  },

  methods: {
    clearSearch() {
      this.localSearch = ""; // Clear the local search field
      this.search = ""; // Clear the actual search field used for filtering
    },
    triggerSearch() {
      this.search = this.localSearch;
    },
    checkTrackingLabes(header) {
      if (header == "cart" && !this.$store.state.ui.msgTrackingState.cart) {
        return false;
      } else if (
        header == "purchase" &&
        !this.$store.state.ui.msgTrackingState.purchase
      ) {
        return false;
      } else {
        return true;
      }
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 200;
    },
    filters_display(val) {
      let name = "";
      if (val === "online") name = "Online";
      else if (val === "priority") name = "Priority";
      else if (val === "sent_at") name = "Date sent";
      else if (val === "waiting") name = "Waiting";
      else if (val === "status") name = "Status";
      else if (val === "status_email") name = "status_email";
      else if (val === "add_to_cart") name = "add_to_cart";
      else if (val === "purchase") name = "purchase";
      return this.$t(`messanger.dash.filters.select.${name}`);
    },
    clear(val) {
      this.btns = {
        btn1: false,
        btn2: false,
      };
      this.$store.state.messages.sorts.status.filter_by = [];
      this.$store.state.messages.filter_rest = this.$store.state.messages.all_messages;
      if (
        this.$store.state.messages.sorts.conversation.filter_by !== "show_all"
      )
        this.$store.state.messages.sorts.conversation.filter_by = "show_all";
      this.$store.state.messages.sorts.sent_at.between = {
        start: null,
        end: null,
      };
      this.$store.state.messages.sorts.waiting.between = {
        start: null,
        end: null,
      };
      this.$store.state.messages.last_page = 1;
      this.$store.state.messages.sorts.selected_sort = this.set_filter;
    },
    initlables() {
      this.headers = [
        {
          box: true,
        },
        {
          text: this.getlable("online"),
          value: "online",
          filterable: false,
          sortable: false,
          align: "center",
          minWidth: "50px",
        },
        {
          text: this.getlable("priority"),
          value: "priority",
          filterable: false,
          align: "center",
          minWidth: "50px",
        },
        {
          text: this.getlable("contact"),
          sortable: true,
          filterable: true,
          value: "contact",
          align: "start",
          minWidth: "70px",
        },
        {
          text: this.getlable("date_sent"),
          align: "start",
          sortable: true,
          filterable: false,
          value: "sent_at",
          minWidth: "150px",
        },
        {
          text: this.getlable("last_msg"),
          value: "last_message",
          filterable: true,
          sortable: false,
          minWidth: "100px",
        },
        {
          text: this.getlable("status"),
          value: "status",
          filterable: false,
          align: "center",
          minWidth: "100px",
        },
        {
          text: this.getlable("conversation_subjects"),
          value: "conversation_subjects",
          filterable: false,
          align: "center",
          minWidth: "50px",
        },
        {
          text: this.getlable("managedBy"),
          filterable: false,
          align: "center",
          sortable: true,
          class: "sort-icon",
          minWidth: "50px",
        },
        {
          text: this.getlable("product"),
          value: "cart",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: this.getlable("purchase"),
          value: "purchase",
          align: "center",
          sortable: false,
          filterable: false,
        },
        {
          text: this.getlable("comments"),
          value: "AdminNote",
          align: "center",
          sortable: false,
          filterable: true,
          minWidth: "150px",
        },
      ];
    },
    updatePage(val) {
      this.page_infos = val;
    },
    getlable(name) {
      return this.$t(`messanger.dash.table_head.${name}`);
    },
    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
        this.receiver_ids = [];
      } else
        for (
          let i = this.page_infos.pageStart;
          i < this.page_infos.pageStop;
          i++
        ) {
          const element = this.filteredDesserts[i];
          this.selected.push(element.i_msg);
          this.receiver_ids.push(element.receiver);
        }
    },
    async paginate(val) {
      if (
        val == this.pageCount &&
        this.$store.state.messages.current_message_length <
          this.$store.state.messages.store_conversation_length
      ) {
        this.$store.dispatch("setCloader", { showing: true });
        this.$store.state.messages.api_msg_pull =
          this.$store.state.messages.api_msg_pull + 1;
        await this.$store
          .dispatch("FETCH_MESSAGES", {
            page: this.$store.state.messages.api_msg_pull,
            type: this.$store.state.messanger_type_selected,
          })
          .then((r) => {
            this.$store.dispatch("setCloader", { showing: false });
            // this.$vuetify.goTo(0);
          })
          .catch((err) => {
            this.$store.dispatch("setCloader", { showing: false });
          });
      }
    },
    msg_delete() {
      const discution = true;
      let ids = this.receiver_ids;
      this.$store
        .dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: this.$t("show_box.msg_del"),
          ligth: true,
        })
        .then((confirmation) => {
          if (confirmation) {
            this.$store.dispatch("setCloader", { showing: true });
            this.$store.dispatch("DELETE_MSG", { ids, discution }).then((r) => {
              this.$socket.emit("DeleteAction", {
                selected: this.selected,
              });
              this.receiver_ids = [];
              this.selected = [];
              this.$store.dispatch("setCloader", { showing: false });
            });
          } else this.$store.dispatch("setCloader", { showing: false });
        });
    },
    async refresh() {
      this.$store.state.messages.loading = true;
      this.$store.dispatch("setCloader", { showing: true });
      if (this.$store.state.ui.msgTrackingState.cart) {
        await this.$store
          .dispatch("FETCH_PRODUCT_ADDED_TO_CART")
          .then((data) => {
            console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if (this.$store.state.ui.msgTrackingState.purchase) {
        await this.$store
          .dispatch("FETCH_PRODUCT_PURCHASE")
          .then((data) => {
            console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
      await this.$store
        .dispatch("FETCH_MESSAGES", {
          page: 0,
          type: this.$store.state.messanger_type_selected,
        })
        .then((r) => {
          this.$store.state.messages.api_msg_pull = 0;
          this.$store.state.messages.loading = false;
          this.$store.state.messages.last_page = 1;
          this.$store.dispatch("setCloader", { showing: false });
        })
        .catch((err) => {
          this.$store.state.messages.loading = false;
          this.$store.dispatch("setCloader", { showing: false });
        });
      this.$store.dispatch("setCloader", { showing: true });
      this.$store.dispatch("CONVERSATION_LENGHT").then((r) => {
        this.$store.dispatch("setCloader", { showing: false });
      });
    },
    notificationState() {
      this.$store.state.messages.NotificationPush = !this.$store.state.messages
        .NotificationPush;
      this.$store.dispatch("setSnackbar", {
        text: `Notifications ${
          this.$store.state.messages.NotificationPush
            ? this.$i18n.locale == "en"
              ? "enabled"
              : "activées"
            : this.$i18n.locale == "en"
            ? "disabled"
            : "désactivées"
        }`,
        top: true,
        timeout: 2000,
      });
    },
  },
};
</script>

<style scoped>
thead > tr > :nth-child(2) {
  text-align: center;
}
thead > tr > :nth-child(4) {
  text-align: center;
}
thead > tr > :nth-child(6) {
  text-align: center;
}

thead > tr > :nth-child(12) span {
  margin-right: 27px;
}
</style>
